import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import './App.css';

const {
  FiArrowRight,
  FiCheckCircle,
  FiUsers,
  FiTrendingUp,
  FiStar,
  FiClock,
  FiShield,
  FiAward,
  FiTarget,
  FiBriefcase,
  FiUserCheck
} = FiIcons;

function App() {
  // アニメーション共通
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };
  const staggerChildren = {
    animate: { transition: { staggerChildren: 0.1 } }
  };

  // 主要CTA：アフィリエイト遷移
  const handleCTAClick = (location) => {
    const affiliateUrl =
      'http://www.rentracks.jp/adx/r.html?idx=0.7613.364211.8929.12674&dna=148584';
    try {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'click', {
          event_category: 'affiliate',
          event_label: 'sincere_' + location
        });
      }
    } catch (e) {
      // no-op
    }
    window.location.href = affiliateUrl;
    return false;
  };

  const handlePrivacyClick = () => {
    window.location.href = '#/privacy';
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ─────────────────────────────────  PR/非公式の明示  */}
      <div className="bg-gray-100 text-center py-2 text-[13px] text-gray-600">
        本ページはアフィリエイト広告（PR）を含みます。<br className="inline md:hidden" />
        当サイトは<strong>シンシアード（Sincereed）の公式サイトではありません</strong>。
      </div>

      {/* ─────────────────────────────────  HERO */}
      <section className="relative bg-gradient-to-br from-slate-50 to-blue-50 py-16 md:py-20 px-4 overflow-hidden">
        {/* 背景（任意） */}
        <div
          className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-15"
          style={{
            backgroundImage:
              'url(https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757731814957-Whisk_2fc41f32e705002836f4e5f18b9c936bdr.jpg)'
          }}
        />
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
            {/* 左：コピー */}
            <div>
              <motion.div
                className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-5"
                {...fadeInUp}
              >
                ハイクラス転職支援
              </motion.div>

              <motion.h1
                className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-5"
                {...fadeInUp}
              >
                あなたの経験に<strong className="text-blue-600">“高く反応する会社”</strong>だけに出会う。
              </motion.h1>

              <motion.p
                className="text-lg md:text-xl text-gray-700 mb-6"
                {...fadeInUp}
                transition={{ delay: 0.15 }}
              >
                最短で面談打診。完全無料。<br className="hidden md:block" />
                ミスマッチを減らす<strong>事前合意型の紹介</strong>に特化しています。
              </motion.p>

              {/* ベネフィット3つ */}
              <motion.ul
                className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8"
                {...fadeInUp}
                transition={{ delay: 0.25 }}
              >
                <li className="bg-white/90 p-4 rounded-lg shadow-sm text-center">
                  <div className="font-bold text-gray-900">合格可能性の高い求人のみ</div>
                  <div className="text-sm text-gray-600 mt-1">事前に温度感を確認して提示</div>
                </li>
                <li className="bg-white/90 p-4 rounded-lg shadow-sm text-center">
                  <div className="font-bold text-gray-900">在職中でも進めやすい</div>
                  <div className="text-sm text-gray-600 mt-1">オンライン中心／非公開配慮</div>
                </li>
                <li className="bg-white/90 p-4 rounded-lg shadow-sm text-center">
                  <div className="font-bold text-gray-900">完全無料</div>
                  <div className="text-sm text-gray-600 mt-1">費用は企業負担で安心</div>
                </li>
              </motion.ul>

              {/* 主要CTA */}
              <motion.button
                className="bg-red-500 hover:bg-red-600 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.03]"
                {...fadeInUp}
                transition={{ delay: 0.35 }}
                onClick={() => handleCTAClick('hero')}
              >
                60秒で無料登録 <SafeIcon icon={FiArrowRight} className="inline ml-2" />
              </motion.button>

              <motion.p
                className="text-[13px] text-gray-500 mt-3"
                {...fadeInUp}
                transition={{ delay: 0.45 }}
              >
                ※シンシアード公式サイトへ遷移します
              </motion.p>
            </div>

            {/* 右：信頼補助カード */}
            <motion.div
              className="bg-white p-7 md:p-8 rounded-2xl shadow-xl"
              {...fadeInUp}
              transition={{ delay: 0.2 }}
            >
              <h3 className="text-xl font-bold text-gray-900 mb-5">選ばれるポイント</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 mr-3 mt-1" />
                  <span className="text-gray-700">年収帯が高い管理職・専門職を中心にご紹介</span>
                </div>
                <div className="flex items-start">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 mr-3 mt-1" />
                  <span className="text-gray-700">職務要約のチューニングで<strong>通過率を底上げ</strong></span>
                </div>
                <div className="flex items-start">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 mr-3 mt-1" />
                  <span className="text-gray-700">非公開求人の事前合意で<strong>無駄打ちゼロ</strong></span>
                </div>
                <div className="flex items-start">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 mr-3 mt-1" />
                  <span className="text-gray-700">完全無料／在職中OK／秘密厳守</span>
                </div>
              </div>

              <button
                className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg transition-colors"
                onClick={() => handleCTAClick('sidebar')}
              >
                無料で始める
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ─────────────────────────────────  実例/権威付け（数値は任意） */}
      <section className="py-14 px-4 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" {...fadeInUp}>
            期待できる価値
          </motion.h2>

          <motion.div
            className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10"
            variants={staggerChildren}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            <motion.div className="bg-gray-50 p-6 rounded-lg" variants={fadeInUp}>
              <SafeIcon icon={FiUsers} className="w-7 h-7 text-blue-600 mx-auto mb-2" />
              <div className="font-semibold text-gray-900">大手商社</div>
              <div className="text-xs text-gray-600">管理職案件の紹介実績</div>
            </motion.div>
            <motion.div className="bg-gray-50 p-6 rounded-lg" variants={fadeInUp}>
              <SafeIcon icon={FiBriefcase} className="w-7 h-7 text-blue-600 mx-auto mb-2" />
              <div className="font-semibold text-gray-900">外資系</div>
              <div className="text-xs text-gray-600">コンサル／金融など</div>
            </motion.div>
            <motion.div className="bg-gray-50 p-6 rounded-lg" variants={fadeInUp}>
              <SafeIcon icon={FiTarget} className="w-7 h-7 text-blue-600 mx-auto mb-2" />
              <div className="font-semibold text-gray-900">IT・テック</div>
              <div className="text-xs text-gray-600">CxO／VPクラス</div>
            </motion.div>
            <motion.div className="bg-gray-50 p-6 rounded-lg" variants={fadeInUp}>
              <SafeIcon icon={FiTrendingUp} className="w-7 h-7 text-blue-600 mx-auto mb-2" />
              <div className="font-semibold text-gray-900">メーカー</div>
              <div className="text-xs text-gray-600">部長・役員クラス</div>
            </motion.div>
          </motion.div>

          {/* 体験談（宣伝調を弱めて安心感を重視） */}
          <motion.div className="bg-blue-50 p-7 rounded-2xl max-w-4xl mx-auto" {...fadeInUp}>
            <div className="flex items-center justify-center mb-3">
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-5 h-5" />
                ))}
              </div>
              <span className="ml-2 text-gray-700 font-medium">ユーザーの声</span>
            </div>
            <blockquote className="text-gray-700 italic">
              「在職中でも無理なく進められ、面談打診までがとても早かった。求人の“温度感”を事前に合わせてくれたので、ムダが少なかったです。」
            </blockquote>
          </motion.div>
        </div>
      </section>

      {/* ─────────────────────────────────  違い（3×2カード） */}
      <section className="py-14 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10"
            {...fadeInUp}
          >
            選ばれる理由
          </motion.h2>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
            variants={staggerChildren}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            {/* 1 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757732767246-%C3%A3%C2%83%C2%8F%C3%A3%C2%82%C2%A4%C3%A3%C2%82%C2%AF%C3%A3%C2%83%C2%A9%C3%A3%C2%82%C2%B9%C3%A7%C2%89%C2%B9%C3%A5%C2%8C%C2%96.jpg"
                  alt="ハイクラス特化"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiTrendingUp} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">ハイクラス特化</h3>
              <p className="text-gray-600">
                管理職・専門職・エグゼクティブのポジションに注力。あなたの経験が活きる案件に絞ってご提案。
              </p>
            </motion.div>

            {/* 2 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757732972576-%C3%A9%C2%9D%C2%9E%C3%A5%C2%85%C2%AC%C3%A9%C2%96%C2%8B%C3%A6%C2%B1%C2%82%C3%A4%C2%BA%C2%BA.jpg"
                  alt="非公開求人"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiShield} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">非公開求人を厳選</h3>
              <p className="text-gray-600">事前合意をとったうえで、合格可能性が高い求人のみをご提示します。</p>
            </motion.div>

            {/* 3 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757733688824-%C3%A5%C2%B0%C2%82%C3%A4%C2%BB%C2%BB%C3%A3%C2%82%C2%B3%C3%A3%C2%83%C2%B3%C3%A3%C2%82%C2%B5%C3%A3%C2%83%C2%AB%C3%A4%C2%BC%C2%B4%C3%A8%C2%B5%C2%B0.jpg"
                  alt="専任コンサルタント"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiUserCheck} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">専任が伴走</h3>
              <p className="text-gray-600">職務要約の磨き込み、面談対策、条件交渉まで一気通貫でサポート。</p>
            </motion.div>

            {/* 4 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757734389048-%C3%A3%C2%82%C2%AA%C3%A3%C2%83%C2%B3%C3%A3%C2%83%C2%A9%C3%A3%C2%82%C2%A4%C3%A3%C2%83%C2%B3%C3%A9%C2%9D%C2%A2%C3%A8%C2%AB%C2%87.jpg"
                  alt="効率的"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiClock} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">在職中でも進めやすい</h3>
              <p className="text-gray-600">面談はオンライン対応。平日夜・週末の調整も柔軟です。</p>
            </motion.div>

            {/* 5 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757735151666-%C3%A5%C2%B9%C2%B4%C3%A5%C2%8F%C2%8E%C3%A3%C2%82%C2%A2%C3%A3%C2%83%C2%83%C3%A3%C2%83%C2%95%C3%A3%C2%82%C2%9A%C3%A5%C2%AE%C2%9F%C3%A7%C2%B8%C2%BE.jpg"
                  alt="年収アップ"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiAward} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">キャリア価値の最大化</h3>
              <p className="text-gray-600">希望に沿って“年収だけでなく職責”も上げる提案を重視します。</p>
            </motion.div>

            {/* 6 */}
            <motion.div className="bg-white p-7 rounded-xl shadow-lg" variants={fadeInUp}>
              <div className="relative mb-5">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757736173677-%C3%A5%C2%AE%C2%8C%C3%A5%C2%85%C2%A8%C3%A7%C2%84%C2%A1%C3%A6%C2%96%C2%99%C3%A7%C2%A7%C2%98%C3%A5%C2%AF%C2%86%C3%A5%C2%8E%C2%B3%C3%A5%C2%AE%C2%88.jpg"
                  alt="無料・秘匿"
                  className="w-full h-44 object-cover rounded-lg"
                />
                <div className="absolute top-3 left-3 bg-blue-600 p-2.5 rounded-full">
                  <SafeIcon icon={FiUsers} className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">完全無料・秘密厳守</h3>
              <p className="text-gray-600">費用は企業からの成功報酬。個人情報は法令に基づき厳格に管理します。</p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ─────────────────────────────────  流れ */}
      <section className="py-14 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10"
            {...fadeInUp}
          >
            ご利用の流れ（最短3ステップ）
          </motion.h2>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
            variants={staggerChildren}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            <motion.div className="text-center" variants={fadeInUp}>
              <div className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-3">
                1
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">60秒で無料登録</h3>
              <p className="text-gray-600 text-sm">基本情報と希望条件だけ。後から編集OK</p>
            </motion.div>
            <motion.div className="text-center" variants={fadeInUp}>
              <div className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-3">
                2
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">ヒアリング（オンライン）</h3>
              <p className="text-gray-600 text-sm">職務要約のチューニング／市場状況の共有</p>
            </motion.div>
            <motion.div className="text-center" variants={fadeInUp}>
              <div className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-3">
                3
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">求人提示＆面談打診</h3>
              <p className="text-gray-600 text-sm">合格可能性が高い案件だけをご案内</p>
            </motion.div>
          </motion.div>

          <motion.div className="text-center mt-10" {...fadeInUp}>
            <button
              className="bg-red-500 hover:bg-red-600 text-white text-lg md:text-xl font-bold py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all"
              onClick={() => handleCTAClick('flow')}
            >
              60秒で無料登録 <SafeIcon icon={FiArrowRight} className="inline ml-2" />
            </button>
          </motion.div>
        </div>
      </section>

      {/* ─────────────────────────────────  FAQ（不安の核心に回答） */}
      <section className="py-14 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <motion.h2
            className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10"
            {...fadeInUp}
          >
            よくあるご質問
          </motion.h2>

          <motion.div
            className="space-y-5"
            variants={staggerChildren}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            <motion.details className="bg-white p-6 rounded-lg group" variants={fadeInUp}>
              <summary className="font-semibold text-gray-900 cursor-pointer flex items-center justify-between">
                <span className="flex items-center">
                  <SafeIcon icon={FiCheckCircle} className="text-blue-600 mr-3" />
                  Q. 登録すると電話がたくさん来ますか？
                </span>
                <SafeIcon icon={FiArrowRight} className="transition-transform group-open:rotate-90" />
              </summary>
              <div className="mt-4 pl-9 text-gray-700">
                A. ご希望がない限り<strong>電話は行いません</strong>。連絡はメール／チャットが中心です。
              </div>
            </motion.details>

            <motion.details className="bg-white p-6 rounded-lg group" variants={fadeInUp}>
              <summary className="font-semibold text-gray-900 cursor-pointer flex items-center justify-between">
                <span className="flex items-center">
                  <SafeIcon icon={FiCheckCircle} className="text-blue-600 mr-3" />
                  Q. 退会やデータ削除はできますか？
                </span>
                <SafeIcon icon={FiArrowRight} className="transition-transform group-open:rotate-90" />
              </summary>
              <div className="mt-4 pl-9 text-gray-700">
                A. マイページから<strong>即時に退会／削除</strong>できます。手続きが不安な場合は窓口で代行対応します。
              </div>
            </motion.details>

            <motion.details className="bg-white p-6 rounded-lg group" variants={fadeInUp}>
              <summary className="font-semibold text-gray-900 cursor-pointer flex items-center justify-between">
                <span className="flex items-center">
                  <SafeIcon icon={FiCheckCircle} className="text-blue-600 mr-3" />
                  Q. 今すぐ転職するか決めていません。相談だけでも大丈夫？
                </span>
                <SafeIcon icon={FiArrowRight} className="transition-transform group-open:rotate-90" />
              </summary>
              <div className="mt-4 pl-9 text-gray-700">
                A. もちろん大丈夫です。市場動向の確認やキャリア相談のみでも歓迎します。
              </div>
            </motion.details>

            <motion.details className="bg-white p-6 rounded-lg group" variants={fadeInUp}>
              <summary className="font-semibold text-gray-900 cursor-pointer flex items-center justify-between">
                <span className="flex items-center">
                  <SafeIcon icon={FiCheckCircle} className="text-blue-600 mr-3" />
                  Q. 費用はかかりますか？
                </span>
                <SafeIcon icon={FiArrowRight} className="transition-transform group-open:rotate-90" />
              </summary>
              <div className="mt-4 pl-9 text-gray-700">
                A. サービスは<strong>完全無料</strong>です（費用は企業側の成功報酬で賄われます）。
              </div>
            </motion.details>
          </motion.div>

          <motion.div className="text-center mt-10" {...fadeInUp}>
            <button
              className="bg-red-500 hover:bg-red-600 text-white text-lg md:text-xl font-bold py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all"
              onClick={() => handleCTAClick('faq')}
            >
              60秒で無料登録 <SafeIcon icon={FiArrowRight} className="inline ml-2" />
            </button>
          </motion.div>
        </div>
      </section>

      {/* ─────────────────────────────────  FINAL CTA */}
      <section className="py-16 px-4 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2 className="text-3xl md:text-5xl font-bold mb-5" {...fadeInUp}>
            次のステージへ。
          </motion.h2>
          <motion.p className="text-lg md:text-2xl mb-7 opacity-90" {...fadeInUp} transition={{ delay: 0.15 }}>
            合格可能性が高い求人だけに出会う転職体験を。
          </motion.p>

          <motion.button
            className="bg-red-500 hover:bg-red-600 text-white text-xl md:text-2xl font-bold py-4 md:py-5 px-10 md:px-14 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-[1.03]"
            {...fadeInUp}
            transition={{ delay: 0.25 }}
            onClick={() => handleCTAClick('final')}
          >
            60秒で無料登録 <SafeIcon icon={FiArrowRight} className="inline ml-3" />
          </motion.button>

          <motion.p className="text-xs md:text-sm mt-5 opacity-80" {...fadeInUp} transition={{ delay: 0.35 }}>
            ※シンシアード公式サイトへ遷移します。面談日程はご都合に合わせて調整可能です。
          </motion.p>
        </div>
      </section>

      {/* ─────────────────────────────────  FOOTER */}
      <footer className="bg-gray-900 text-white py-10 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <div className="text-2xl font-bold mb-2">厳選企業転職ナビ</div>
          <p className="text-gray-400 mb-5">厳選した企業の非公開求人をあなたに。</p>

          <div className="border-t border-gray-700 pt-5">
            <p className="text-gray-400 text-sm mb-2">© 2025 厳選企業転職ナビ. All rights reserved.</p>
            <div className="flex justify-center gap-6 text-sm text-gray-500">
              <a href="/privacy.html" className="hover:text-white transition-colors">
                プライバシーポリシー
              </a>
              <a href="/tokusyo.html" className="hover:text-white transition-colors">
                特定商取引法
              </a>
            </div>
            <p className="text-gray-500 text-xs mt-4">広告・PR表記：本ページはアフィリエイト広告を含みます</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;